/**
 * Applies URLParam-initialized service/item robustly (case/trim-insensitive).
 */

import { useEffect } from "react";
import { normalize, selectionFrom } from "../constants";

export default function useApplyUrlServiceAndItem({
  storeSelection,
  services,
  selectedService,
  setSelectedService,
  serviceItems,
  selectedItem,
  setSelectedItem,
}) {
  useEffect(() => {
    try {
      if (storeSelection?.from !== selectionFrom.urlParams) return;

      const requestedServiceName =
        typeof storeSelection.source === "string"
          ? storeSelection.source
          : storeSelection.source?.Name || storeSelection.source?.name;

      if (!requestedServiceName) return;

      if (
        !selectedService ||
        normalize(selectedService.Name) !== normalize(requestedServiceName)
      ) {
        const found = (services || []).find(
          (s) => normalize(s.Name) === normalize(requestedServiceName),
        );
        if (found) setSelectedService(found);
      }
    } catch (e) {
      console.error("ZoomToGeo: error applying URL service", e);
    }
  }, [storeSelection, services, selectedService, setSelectedService]);

  useEffect(() => {
    try {
      if (storeSelection?.from !== selectionFrom.urlParams) return;

      const requestedItemLabel =
        typeof storeSelection.entity === "string"
          ? storeSelection.entity
          : storeSelection.entity?.displayLabel;

      if (!requestedItemLabel) return;

      if (
        !selectedItem ||
        normalize(selectedItem?.displayLabel) !== normalize(requestedItemLabel)
      ) {
        const found = (serviceItems || []).find(
          (it) => normalize(it.displayLabel) === normalize(requestedItemLabel),
        );
        if (found) setSelectedItem(found);
      }
    } catch (e) {
      console.error("ZoomToGeo: error applying URL service-item", e);
    }
  }, [storeSelection, serviceItems, selectedItem, setSelectedItem]);
}
